<template>
    <a :href="post.url">
        <article class="blog-item">
            <div class="blog-item__inner">
                <div class="blog-item__media">
                    <img class="blog-item__image" v-if="post?.image?.src" :src="post.image.src" :alt="post.image.alt || post.title" />
                </div>
                <div class="blog-item__content">
                    <hgroup class="blog-item__heading">
                        <span class="blog-item__category" v-if="post?.categories?.[0]?.title">{{ post.categories[0].title }}</span>
                        <h2 class="blog-item__title">{{ post?.title }}</h2>
                    </hgroup>
                    <div class="blog-post__description">
                        <p v-if="post?.description">{{ post.description }}</p>
                        <div class="blog-item__meta">
                            <span v-if="post?.publishDate">Posted <time :datetime="post.publishDate">{{ formatDate(post.publishDate) }}</time></span>
                            <span v-if="authors(post)">By {{ authors(post) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    </a>
</template>

<script setup>
import { format } from 'date-fns';
import { defineProps } from 'vue';

defineProps({
    post: {
        type: Object,
        required: true
    }
});

const short_months = ['3','4','5','6','7'];
function formatDate(dateString) {
    const date = new Date(dateString);

    return short_months.includes(format(date, 'M')) ?
        format(date, 'MMMM d') :
        format(date, 'MMM d');
}

function authors(post) {
    if (!post.authors) {
        return false;
    }
    return post.authors
        .map(a => a.displayName ?? (a.firstName + ' ' + a.lastName))
        .join(', ')
        .trim();
}
</script>
